import { useState } from "react";
import { Field, ErrorMessage } from "formik";
import "./KidDetailsForm.css";

export const KidDetailsForm = ({
  index,
  price,
  currencySymbol = "₹",
  billingPeriod = "/year",
  onRemove,
  showRemove,
  canRemove = true,
  kidAge,
  status = "new",
  isDeleting = false,
  disabled = false,
}) => {
  const isOlderThan12 = kidAge > 12;
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className="kidDetailsForm">
      <div className="kidDetailsForm__header">
        <div className="kidDetailsForm__titleWrap">
          <h3 className="kidDetailsForm__title">
            Details: <strong>Kid {index + 1}</strong>
          </h3>
          <span
            className={`kidDetailsForm__badge ${status === "old"
                ? "kidDetailsForm__badge--old"
                : "kidDetailsForm__badge--new"
              }`}
          >
            {status === "old" ? "Existing" : "New"}
          </span>
        </div>
        <div className="kidDetailsForm__priceWrap">
          <span className="kidDetailsForm__price">
            {currencySymbol}
            {price}
            {billingPeriod && (
              <span className="kidDetailsForm__pricePeriod">
                {billingPeriod}
              </span>
            )}
          </span>
          {showRemove && canRemove && (
            <button
              type="button"
              className={`kidDetailsForm__removeBtn ${isDeleting ? "kidDetailsForm__removeBtn--loading" : ""
                }`}
              onClick={() => onRemove(index)}
              title={status === "old" ? "Delete Student" : "Remove Kid"}
              disabled={isDeleting || disabled}
            >
              {isDeleting ? <span className="kidDetailsForm__spinner" /> : "✕"}
            </button>
          )}
        </div>
      </div>
      <div className="kidDetailsForm__body">
        <div className="kidDetailsForm__inputRow">
          <div className="kidDetailsForm__fieldWrap">
            <Field
              type="text"
              name={`kids.${index}.firstName`}
              className="kidDetailsForm__input"
              placeholder="Kid's First Name"
              disabled={disabled}
            />
            <ErrorMessage
              name={`kids.${index}.firstName`}
              component="div"
              className="kidDetailsForm__error"
            />
          </div>
          <div className="kidDetailsForm__fieldWrap">
            <Field
              type="text"
              name={`kids.${index}.lastName`}
              className="kidDetailsForm__input"
              placeholder="Kid's Last Name"
              disabled={disabled}
            />
            <ErrorMessage
              name={`kids.${index}.lastName`}
              component="div"
              className="kidDetailsForm__error"
            />
          </div>
        </div>
        <div className="kidDetailsForm__inputRow">
          {!isOlderThan12 && (
            <div className="kidDetailsForm__fieldWrap">
              <Field
                type="text"
                name={`kids.${index}.username`}
                className="kidDetailsForm__input"
                placeholder="Kid's Username"
                disabled={disabled}
                autoComplete="new-password"
              />
              <ErrorMessage
                name={`kids.${index}.username`}
                component="div"
                className="kidDetailsForm__error"
              />
            </div>
          )}
          <div className="kidDetailsForm__fieldWrap">
            <Field
              type="number"
              name={`kids.${index}.age`}
              className="kidDetailsForm__input"
              placeholder="Kid's Age"
              disabled={disabled}
            />
            <ErrorMessage
              name={`kids.${index}.age`}
              component="div"
              className="kidDetailsForm__error"
            />
          </div>
        </div>
        {/* Show email field for any student (new or old) when age > 12 */}
        {/* Show password field only for new students when age <= 12 */}
        {(status !== "old" || isOlderThan12) && (
          <div className="kidDetailsForm__inputRow">
            {isOlderThan12 ? (
              <div className="kidDetailsForm__fieldWrap kidDetailsForm__fieldWrap--full">
                <Field
                  type="email"
                  name={`kids.${index}.email`}
                  className="kidDetailsForm__input kidDetailsForm__input--full"
                  placeholder="Kid's Email"
                  disabled={disabled}
                  autoComplete="new-password"
                />
                <ErrorMessage
                  name={`kids.${index}.email`}
                  component="div"
                  className="kidDetailsForm__error"
                />
              </div>
            ) : (
              <div className="kidDetailsForm__fieldWrap kidDetailsForm__fieldWrap--full">
                <div className="kidDetailsForm__passwordWrap">
                  <Field
                    type={showPassword ? "text" : "password"}
                    name={`kids.${index}.password`}
                    className="kidDetailsForm__input kidDetailsForm__input--full"
                    placeholder="Kid's Password"
                    disabled={disabled}
                    autoComplete="new-password"
                  />
                  <button
                    type="button"
                    className="kidDetailsForm__togglePwd"
                    onClick={() => setShowPassword((prev) => !prev)}
                    tabIndex={-1}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                  >
                    <i
                      className={`fa ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
                    />
                  </button>
                </div>
                <ErrorMessage
                  name={`kids.${index}.password`}
                  component="div"
                  className="kidDetailsForm__error"
                />
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
